import * as Immutable from 'immutable';
import UserCartStore, { CartItem, BaseItem, ShippingType } from '../_stores/UserCartStore';
import { Price } from '../../UIData/_stores/UIDataStore';
import { UserCartAction, UserCartActionType, } from '../_actions/UserCartActions';

const UserCartReducer = (store:UserCartStore = new UserCartStore(), action: UserCartAction):UserCartStore => {
	switch (action.type) {
		case UserCartActionType.EditCart:
			store = new UserCartStore(action.cart);
		break;
	}

	return store;
}

export default UserCartReducer